/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { SecurityKeyBIcon16Light } from './SecurityKeyBIcon16Light';
import { SecurityKeyBIcon16Regular } from './SecurityKeyBIcon16Regular';
import { SecurityKeyBIcon16Solid } from './SecurityKeyBIcon16Solid';
import { SecurityKeyBIcon20Light } from './SecurityKeyBIcon20Light';
import { SecurityKeyBIcon20Regular } from './SecurityKeyBIcon20Regular';
import { SecurityKeyBIcon20Solid } from './SecurityKeyBIcon20Solid';
import { SecurityKeyBIcon24Regular } from './SecurityKeyBIcon24Regular';
import { SecurityKeyBIcon24Solid } from './SecurityKeyBIcon24Solid';
import { SecurityKeyBIcon32Regular } from './SecurityKeyBIcon32Regular';
import { SecurityKeyBIcon64Regular } from './SecurityKeyBIcon64Regular';
var sizes = {
    16: {
        light: SecurityKeyBIcon16Light,
        regular: SecurityKeyBIcon16Regular,
        solid: SecurityKeyBIcon16Solid,
    },
    20: {
        light: SecurityKeyBIcon20Light,
        regular: SecurityKeyBIcon20Regular,
        solid: SecurityKeyBIcon20Solid,
    },
    24: {
        regular: SecurityKeyBIcon24Regular,
        solid: SecurityKeyBIcon24Solid,
    },
    32: {
        regular: SecurityKeyBIcon32Regular,
    },
    64: {
        regular: SecurityKeyBIcon64Regular,
    },
};
export var SecurityKeyBIcon = forwardRef('SecurityKeyBIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
